import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";

interface ICustomAcademicYearInput {
  parentCallback?: (x: number) => void;
  schoolId: string;
  isDisabled?: boolean;
  isRequired?: boolean;
}

const CustomAcademicYearInput = ({
  parentCallback,
  schoolId,
  isDisabled,
  isRequired,
}: ICustomAcademicYearInput) => {
  return (
    <ReferenceInput
      label="Academic Year"
      source="academicYearId"
      reference="academicYears"
      filter={{ SchoolId: schoolId ? Number(schoolId) : 0 }}
      onChange={({ target }) => {
        parentCallback && parentCallback(target.value);
      }}
      validate={isRequired ? required() : undefined}
      disabled={isDisabled}
    >
      <SelectInput optionText="name" optionId="id" />
    </ReferenceInput>
  );
};

export default CustomAcademicYearInput;
